import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

type ImpactStatementProps = {
  content: string;
};

export const ImpactStatement: React.FC<ImpactStatementProps> = ({ content }) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div
      ref={ref}
      className={`my-48 py-24 transform transition-all duration-1000 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 border-l-2 border-zinc-300 dark:border-zinc-700 pl-8">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-light text-zinc-800 dark:text-zinc-200 leading-tight md:leading-tight lg:leading-tight">
          {content}
        </h3>
      </div>
    </div>
  );
}; 